import React, { useContext, useState, useEffect } from 'react';
import AIG from "../../../assets/Logo/AIG";
import Automoby from "../../../assets/Logo/Automoby";
import Autonomo from "../../../assets/Logo/Autonomo";
import At from "../../../assets/Icon/At";
import Lock from "../../../assets/Icon/Lock";
import cl from './Login.module.css'
import Form from '../../../assets/Style/Form.module.css'
import { Link, Navigate, redirect } from 'react-router-dom'; 
import { useAuth } from '../../../providers/authProvider'; 
import { AppContext } from '../../../providers/appProvider';
import ErrorModal from '../ErrorModal/ErrorModal';
import OkModal from '../OkModal/OkModal';
import { baseFileURL } from '../../../Api';
import ContainerLogo from '../../../assets/Logo/ContainerLogo';
import { useTranslation } from 'react-i18next';
import Flag from '../../UI/Flag/Flag';
 

function Login() {
    const { t, i18n } = useTranslation();
    const auth = useAuth()
    const { appState, app } = useContext(AppContext);

    const [login, setLogin] = useState("")
    const [password, setPassword] = useState("")
  
    useEffect(() => {
        if (baseFileURL === 'https://crm.autonomo.kz') {
            // external redirect to another domain
            window.location.href = 'https://www.google.com/';
        }
    }, []);

    if (auth.isLoggedIn && baseFileURL === 'https://i-logistics.net') {
        return   <Navigate to="/containers"  />  
    }  else if (auth.isLoggedIn ) {
        return   <Navigate to="/finances"  />
    }
    
    
    const handleSubmit = async (e) => {
        e.preventDefault(); 
        try {
            const response = await auth.login(login, password)
        } catch (error) {
            app.setError(t('InvalidPassword'))
        }
    }

    return <div className='themeCRM' data-theme="light" data-company={
        baseFileURL === 'https://i-logistics.net' || baseFileURL === 'https://dev.i-logistics.net' ? (
            'ilogistics'
        ) : baseFileURL === 'https://finance.automoby.ge' ? (
            'automoby'
        ): baseFileURL === 'https://crm.autonomo.kz' ? (
            'autonomo'
        ) : baseFileURL === 'https://crm.aig.com.ge' || baseFileURL === 'https://crmdev.aig.com.ge'   ? (
            'aig'
        ) : (
       'automoby'
    )} style={{ height: '100vh' }}>
        <div className={cl.bgLight} >
            <div className={cl.Page} >
                <div className={cl.Head} >
                    {baseFileURL === 'https://i-logistics.net' || baseFileURL === 'https://dev.i-logistics.net' ? (
                        <div className={cl.LogoContainer}>
                            <ContainerLogo  />
                            <span>i-Logistics</span>  
                        </div>
                    ) : baseFileURL === 'https://finance.automoby.ge' ? (
                        <Automoby /> 
                    ): baseFileURL === 'https://crm.autonomo.kz' ? (
                         <Autonomo/> 
                    ) : baseFileURL === 'https://crm.aig.com.ge' || baseFileURL === 'https://crmdev.aig.com.ge'  ? (
                        <AIG />
                    ) : (
                        <Automoby /> 
                    )}
                


                        <div className={cl.langlist}>
                                <span
                                className={i18n.language === 'ka' ? cl.langActive : ''}
                                onClick={() => i18n.changeLanguage('ka')}
                                >
                                <Flag countryCode={'ge'} />
                                </span>
                                <span
                                className={i18n.language === 'en' ? cl.langActive : ''}
                                onClick={() => i18n.changeLanguage('en')}
                                >
                                <Flag countryCode={'gb'} />
                                </span>
                                <span
                                className={i18n.language === 'ru' ? cl.langActive : ''}
                                onClick={() => i18n.changeLanguage('ru')}
                                >
                                <Flag countryCode={'ru'} />
                                </span>
                        </div>



                </div>
                <div className={cl.Box} >
                {appState.ok && <OkModal message={appState.ok} onClose={() => app.clearOk(false)} />}
                {appState.error && <ErrorModal message={appState.error} onClose={() => app.clearError(false)} />}


                    <form className={cl.Form} onSubmit={handleSubmit}>
                        <div className={Form.groupInput}>
                            <label>{t('Email')}</label>
                            <div className={Form.groupInputIcon}>
                                <input
                                    type="email"
                                    className={Form.input}
                                    value={login}
                                    onInput={(e) => {
                                        e.target.value = e.target.value.replace(/[^A-Za-z0-9.@\-_]/g, '').toUpperCase();
                                    }}
                                    onChange={e => setLogin(e.target.value)}
                                />
                                <div className={Form.crmIcon}>
                                    <At />
                                </div>
                            </div>
                        </div>
                        <div className={Form.groupInput}>
                            <label>{t('Password')}</label>
                            <div className={Form.groupInputIcon}>
                                <input
                                    type="password"
                                    className={Form.input} 
                                    value={password}
                                    onChange={e => setPassword(e.target.value)}
                                />
                                <div className={Form.crmIcon}>
                                    <Lock />
                                </div>
                            </div>
                        </div>

                        <Link to="/forgot-password"  style={{ textDecoration: 'underline' }} >{t('ForgotPassword')} </Link>
 
                        <div className={Form.groupInput + ' ' + cl.mt1}>
                            <button type="submit" className={cl.btnPrimary}>{t('Authorization')}</button>
                        </div>
                        
                        <Link to="/register"  className={  cl.AddBtn } >{t('NewUser')} </Link>
 
                    </form>
                </div>
            </div>
        </div>  
    </div> ;
}

export default Login;
